import {Link} from '../../../atoms/Link';
import {Typography} from '../../../atoms/Typography';
import {useIsExtraLargeAndUp} from '../../../hooks/useMatchQuery';
import './AccountDetailsProCTA.sass';

export const AcctDetailsProCTA = ({user}) => {
  const isExtraLargeAndUp = useIsExtraLargeAndUp();

  if (user.subscriptionPlanName) {
    return null;
  }

  return (
    <Link className="acct-details-drawer__pro-cta" href="/pro">
      <Typography variant="paragraph2" className="acct-details-drawer__pro-cta-text">
        Hosting 3+ events this year? Save an average of $380/yr!
      </Typography>
      <div data-qa-id="EviteProAcctDrawerItem" className="button primary">
        {isExtraLargeAndUp ? 'Get Pro' : 'Get Evite Pro'}
      </div>
    </Link>
  );
};
